export function locationModel() {
    this.active = true;
    this.address = "";
    this.addressEN = "";
    this.id = null;
    this.name = "";
    this.nameEN = "";
    this.workingDay = "";
    this.workingDayEN = "";
    this.pickupWorkingDay = "";
    this.pickupWorkingDayEn = "";
    this.latitude = null;
    this.longtitude = null;
    this.referenceCode = ''

    this.setValueFormApi = function(dict) {
        this.active = dict.Active;
        this.address = dict.Address;
        this.addressEN = dict.AddressEN;
        this.id = dict.ID;
        this.name = dict.Name;
        this.nameEN = dict.NameEN;
        this.workingDay = dict.WorkingDay;
        this.workingDayEN = dict.WorkingDayEN;
        this.pickupWorkingDay = dict.PickupWorkingDay;
        this.pickupWorkingDayEn = dict.PickupWorkingDayEn;
        this.latitude = dict.Latitude;
        this.longtitude = dict.Longtitude;
        this.referenceCode = dict.ReferenceCode;
        return this;
    }

    this.setValueFormCache = function(dict) {
        this.active = dict.active;
        this.address = dict.address;
        this.addressEN = dict.addressEN;
        this.id = dict.id;
        this.name = dict.name;
        this.nameEN = dict.nameEN;
        this.workingDay = dict.workingDay;
        this.workingDayEN = dict.workingDayEN;
        this.pickupWorkingDay = dict.pickupWorkingDay;
        this.pickupWorkingDayEn = dict.pickupWorkingDayEn;
        this.latitude = dict.latitude;
        this.longtitude = dict.longtitude;
        this.referenceCode = dict.referenceCode;
        return this;
    }

    this.setValueFormBranchModel = function(dict) {
        this.active = true;
        this.address = dict.address;
        this.addressEN = dict.addressEN;
        this.id = dict.id;
        this.name = dict.name;
        this.nameEN = dict.nameEN;
        this.workingDay = dict.workingDay;
        this.workingDayEN = dict.workingDayEn;
        this.pickupWorkingDay = dict.pickupWorkingDay;
        this.pickupWorkingDayEn = dict.pickupWorkingDayEn;
        this.latitude = dict.location.latitude;
        this.longtitude = dict.location.longitude;
        this.referenceCode = dict.location.referenceCode;
        return this;
    }
}